module.exports = __webpack_public_path__ + "static/MARV5UFSL61JVJBM_new-bb7213fbf29aa6c1fd375d06bae985fe.mp4";